export function isTiptapTokenCloseReason(reason: string): boolean {
    const normalized = reason.toLowerCase();
    return normalized.includes('jwt') || normalized.includes('permission-denied');
}
